import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { GridCol } from '../GridCol';
var textPaddingMap = {
  medium: '40px',
  large: '80px'
};
var imageHorizontalPaddingMap = {
  none: '12px',
  large: '88px'
};
var imageVerticalPaddingMap = {
  none: '0',
  medium: '40px'
};
var TextWrap = styled(GridCol).withConfig({
  displayName: "partials__TextWrap",
  componentId: "sc-3u7zx2-0"
})(["display:flex;flex-direction:column;svg:first-child + *{margin-top:32px;}", " ", ";"], maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    svg:first-child {\n      width: 40px;\n      height: 40px;\n    }\n  "]))), minMediaQueries.miniDesktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding-top: ", ";\n  "])), function (props) {
  return textPaddingMap[props.padding] || '0';
}));
var ImageWrap = styled(GridCol).withConfig({
  displayName: "partials__ImageWrap",
  componentId: "sc-3u7zx2-1"
})(["padding-top:", ";", ";", ";"], function (props) {
  return imageVerticalPaddingMap[props.padding] || '0';
}, maxMediaQueries.phone(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding-top: 0;\n    padding-left: ", ";\n    padding-right: ", ";\n    margin-bottom: 40px;\n  "])), function (props) {
  return imageHorizontalPaddingMap[props.mobilePadding] || '30px';
}, function (props) {
  return imageHorizontalPaddingMap[props.mobilePadding] || '30px';
}), maxMediaQueries.phablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (props) {
  return props.hideBelowDesktop && "\n      display: none; \n    ";
}));
export { TextWrap, ImageWrap };